export function randColor(text) {
  const ascii = text?.charCodeAt(0) % 5;
  const colorArr = ['#B3E5FC', '#F8BBD0', '#E1BEE7', '#FFCDD2', '#F0F4C3'];
  return colorArr[ascii];
}
